module.exports = __webpack_public_path__ + "static/media/SI.0efc3cb1.svg";